import React, { Component } from 'react';
import { classSet } from '@umu/umu-dom';
import { IUserMedal } from '@umu/umu-types';
import { getMedalIcon } from '@umu/umu-util';
import { PreImg } from 'common/src/components';
import { transformPx2Rem } from '../../../@utils';
import './userMedalIcon.scss';

interface IUserMedalIconProps {
    userMedalInfo?: IUserMedal;
    userMedalWidth: 20 | 30 | 16 | 12;
    isTransformPx2Rem?: boolean;
}
const isInUSE = (window as any).isInUSE || window.location.pathname.startsWith('/use');
export default class UserMedalIcon extends Component<IUserMedalIconProps, {}> {
    public render() {
        if (isInUSE) {
            return null;
        }
        let size;
        const { userMedalWidth, isTransformPx2Rem = true } = this.props;
        if (userMedalWidth) {
            size = {
                width: isTransformPx2Rem ? transformPx2Rem(userMedalWidth + 'px') : userMedalWidth + 'px',
                height: isTransformPx2Rem ? transformPx2Rem(userMedalWidth + 'px') : userMedalWidth + 'px',
            };
        }

        const { userMedalInfo } = this.props;
        if (!userMedalInfo) {
            return null;
        }

        const medalIcon = getMedalIcon(userMedalInfo.medal_type, userMedalInfo.medal_rank, 'S');
        const userMedalClass = classSet({
            'user-medal': true,
            'keep-px': !isTransformPx2Rem,
        });
        return (
            <div className="user-medal-icon">
                <div className={userMedalClass} style={size}>
                    <div className="img">
                        <PreImg>
                            <img src={medalIcon} alt="" />
                        </PreImg>
                    </div>
                </div>
            </div>
        );
    }
}
